<router-outlet></router-outlet>
<div toastContainer></div>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.2)"
  size="medium"
  color="#ffffff"
  type="ball-spin-clockwise"
  [fullScreen]="true"
>
</ngx-spinner>

